<template>
  <div class="ui right sidebar">
    <!-- Dynamic platform links -->
    <p
      v-for="vertical in $bus.siteData.verticals"
      :key="vertical.id"
      class="link"
      @click="routeAndClose(vertical.link, vertical.link.startsWith('http'))"
    >
      {{ vertical.name }}
    </p>

    <!-- Static navigation links -->
    <p @click="routeAndClose('/about')" class="link">About Us</p>
    <p @click="routeAndClose('/partners')" class="link">Partners</p>
    <p @click="routeAndClose('/gallery')" class="link">Gallery</p>
    <p v-if="!$bus.isLoggedIn" @click="openAuthAndClose" class="link">
      Sign In
    </p>
  </div>
</template>

<script>
export default {
  name: "sidebar",
  methods: {
    openAuthAndClose: function () {
      this.$emit("close");
      this.$bus.openAuth("login");
    },
    routeAndClose: function (route, isLink = false) {
      if (isLink) {
        this.$bus.redirect(route, false, true);
      }
      this.$router.push(route);
      this.$emit("close");
    },
  },
};
</script>

<style lang="css">
.pushable > .pusher {
  overflow: scroll;
}
.sidebar {
  right: 0px;
  top: 0px;
  width: 220px;
  height: 100%;
  position: fixed;
  background: white;
  z-index: 5000;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sidebar .link {
  margin: 20px 0px;
  font-size: 20px;
  cursor: pointer;
  transition: 0.15s;
  position: relative;
  text-transform: uppercase;
  font-weight: 600;
  text-align: left;
  padding-left: 40px;
}

.sidebar .link:hover {
  color: #b98744;
}
.sidebar .link:active {
  color: #8d6235;
}
</style>
